import CommonContainer from "../Container/CommonContainer";
import { useEffect, useState } from 'react';
import CommonPagination from '../../Common/CommonPagination';
import { FaSearch, FaSpinner } from "react-icons/fa";
import * as RegistrationTrackingReportService from '../../Services/MHL_Reports/RegistrationTrackingReportService';
import toast from "react-hot-toast";
import { Download, Loader2 } from "lucide-react";
import Popover from '../../Common/Popper';

const RegistrationTrackingReportComponent = () => {

    const [registrationData, setRegistrationData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [isDownloadingReport, setIsDownloadingReport] = useState(false);
    const itemsPerPage = 15;

    const [dateRangeOption, setDateRangeOption] = useState('TODAY');

    const getRegistrationTrackingData = (period) => {
        RegistrationTrackingReportService.RegistrationTrackingReport(period)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setRegistrationData(data?.Data);
                } else {
                    setRegistrationData([]);
                }
            })
            .catch(() => {
                setRegistrationData([]);
            });
    };

    useEffect(() => {
        getRegistrationTrackingData(dateRangeOption);
    }, [dateRangeOption]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const filteredRegistrationData = registrationData.filter((data) => {
        const lowerSearch = searchTerm.toLowerCase();
        return (
            data.Partner_Code?.toLowerCase().includes(lowerSearch) ||
            data.Partner_Name?.toLowerCase().includes(lowerSearch) ||
            data.EmailId?.toLowerCase().includes(lowerSearch) ||
            data.Mobile_No?.toString().includes(searchTerm)
        );
    });

    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentRegistrationData = filteredRegistrationData.slice(indexOfFirst, indexOfLast);

    const handleDownloadReport = async () => {
        setIsDownloadingReport(true);
        try {
            const response = await RegistrationTrackingReportService.DownloadRegistrationTrackingReport(dateRangeOption, '');
            const resData = response.data;

            if (!resData?.IsSuccess || !resData?.Data) {
                toast.error("Failed to download report");
                return;
            }

            const byteCharacters = atob(resData.Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = "Registration_Tracking_Report.xlsx";
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error("Download failed");
        } finally {
            setIsDownloadingReport(false);
        }
    };

    const getShortName = (char, limit = 15) => {
        const full = `${char || ""}`.trim();
        if (!full) return "-";
        return full.length > limit ? full.substring(0, limit) + "..." : full;
    };

    return (
        <CommonContainer heading="Registration Tracking">
            <div className="d-flex flex-column flex-lg-row mb-2 date-search-content gap-2 search-sm" style={{ justifyContent: "space-between" }}>
                <div className="d-flex flex-column flex-md-row gap-2">
                    {/* <div className="d-flex align-items-center gap-2 custom-date-range">
                        <select
                            className="form-select date-range-select"
                            style={{}}
                            value={dateRangeOption}
                            onChange={(e) => setDateRangeOption(e.target.value)}
                        >
                            <option value="TODAY">Today</option>
                            <option value="LAST_7_DAYS">Last 7 Days</option>
                            <option value="LAST_30_DAYS">Last 30 Days</option>
                            <option value="MTD">MTD</option>
                        </select>
                    </div> */}

                    <div className="d-flex align-items-center gap-2">
                        <button
                            className="btn custom-sumbitbtn d-flex align-items-center justify-content-center gap-2"
                            onClick={handleDownloadReport}
                            title="Download Report"
                        >
                            {isDownloadingReport ? (
                                <>
                                    <FaSpinner className="w-5 h-5 fa-spin" />
                                    Downloading...
                                </>
                            ) : (
                                <>
                                    <Download size={18} />
                                    Download Report
                                </>
                            )}
                        </button>
                    </div>
                </div>
                <div className="search-box" style={{ position: "relative" }}>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{ paddingRight: "35px", borderRadius: "5px", border: "1px solid #ddd" }}
                    />
                    <button
                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-box-btn"
                        style={{
                            padding: '5px',
                            position: "absolute",
                            right: "0px",
                            height: "35px",
                            width: "45px",
                            top: "50%",
                            borderTopLeftRadius: "0",
                            borderBottomLeftRadius: "0",
                            transform: "translateY(-45%)"
                        }}
                        onClick={() => setCurrentPage(1)}
                    >
                        <FaSearch />
                    </button>
                </div>
            </div>

            <div className="mt-3 mt-lg-2">
                <div className="table-responsive mhl-registration-report-table">
                    <table className="table table-bordered custom-table">
                        <thead>
                            <tr>
                                <th>Partner Details</th>
                                <th>Org Sbu</th>
                                <th>Primary Org</th>
                                <th>Is B2b Registration Allow</th>
                                <th>Today</th>
                                <th>Yesterday</th>
                                <th>Last 7 Days</th>
                                <th>Mtd</th>
                                <th>Last 30 Days</th>
                                <th>Till Date</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "10px" }}>
                            {currentRegistrationData?.length > 0 ? (
                                currentRegistrationData?.map((data, index) => (
                                    <tr key={index}>
                                        {/* <td>{data?.Partner_Code}</td> */}
                                        {/* <td>{data?.Partner_Name}</td> */}

                                        <td style={{ textAlign: "left", verticalAlign: "middle", paddingLeft: '15px' }}>
                                            <Popover
                                                content={
                                                    <div style={{ textAlign: "left" }}>
                                                        <p><strong>Partner Code:</strong> {data.Partner_Code}</p>
                                                        <p><strong>Partner Name:</strong> {data.Partner_Name}</p>
                                                    </div>
                                                }
                                            >

                                                <b>{getShortName(data.Partner_Code)}</b> - {getShortName(data.Partner_Name)}
                                            </Popover>

                                        </td>
                                        <td>{data?.Org_Sbu}</td>
                                        <td>{data?.Primary_Org}</td>
                                        <td>{data?.Is_B2b_Registration_Allow}</td>
                                        <td>{data?.Today_Count}</td>
                                        <td>{data?.Yesterday_Count}</td>
                                        <td>{data?.Last_7_Days_Count}</td>
                                        <td>{data?.Mtd_Count}</td>
                                        <td>{data?.Last_30_Days_Count}</td>
                                        <td>{data?.Till_Date_Count}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center">
                                        No Data found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {filteredRegistrationData.length > itemsPerPage && (
                    <CommonPagination
                        pageList={filteredRegistrationData}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        setCurrentPage={setCurrentPage}
                    />
                )}
            </div>
        </CommonContainer>
    )
}

export default RegistrationTrackingReportComponent